import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { CheckCircle2, Printer, FileText } from "lucide-react";
import { formatCurrency, formatDate } from "../../lib/utils";
import { printInvoice } from "../../lib/invoicePrint";
import { POSEmailInvoice } from "./POSEmailInvoice";

const methodLabel = { NU: "Numerário", CC: "Multicaixa", TB: "Transferência", OU: "Outro" };

export const POSInvoiceModal = ({ result, onClose, settings }) => {
  const inv = result?.invoice;
  return (
    <Dialog open={!!result} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="pos-invoice-modal">
        {inv && (
          <>
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <CheckCircle2 className="w-5 h-5 text-emerald-500" />
                {result.credit ? "Venda a crédito registada" : "Pagamento concluído"}
              </DialogTitle>
              <DialogDescription>Fatura emitida com sucesso{result.tableLabel ? ` — ${result.tableLabel}` : ""}.</DialogDescription>
            </DialogHeader>
            <div className="flex items-center justify-between rounded-lg bg-emerald-600/15 border border-emerald-500/40 p-3">
              <div>
                <p className="text-xs text-muted-foreground">
                  {result.tableLabel}
                  {result.orderNumber ? ` · Pedido #${result.orderNumber}` : ""}
                </p>
                <p className="text-xl font-black font-mono" data-testid="pos-invoice-number">{inv.invoice_number}</p>
              </div>
              <span className="px-2.5 py-1 rounded bg-emerald-600 text-white text-xs font-black tracking-wide" data-testid="pos-paid-badge">
                {result.credit ? "A CRÉDITO" : "PAGA"}
              </span>
            </div>
            <dl className="grid grid-cols-2 gap-x-4 gap-y-1.5 text-sm">
              <dt className="text-muted-foreground">Assinatura</dt>
              <dd className="font-mono text-right" data-testid="pos-invoice-hash-print">{inv.hash_print || "—"}{inv.training ? " · FORMAÇÃO" : ""}</dd>
              <dt className="text-muted-foreground">Data</dt>
              <dd className="text-right">{inv.created_at ? formatDate(inv.created_at) : ""}</dd>
              <dt className="text-muted-foreground">Cliente</dt>
              <dd className="text-right truncate">{inv.customer_name || "Consumidor Final"}</dd>
              <dt className="text-muted-foreground">NIF</dt>
              <dd className="text-right font-mono">{inv.customer_nif || "999999999"}</dd>
              <dt className="text-muted-foreground">Pagamento</dt>
              <dd className="text-right">{result.credit ? "Crédito" : inv.payment_method_label || methodLabel[inv.payment_method] || inv.payment_method}{inv.tpa_name && !(inv.payment_method_label || "").includes(inv.tpa_name) ? <span className="block text-xs text-muted-foreground" data-testid="pos-invoice-tpa">{inv.tpa_name.toUpperCase().startsWith("TPA") ? inv.tpa_name : `TPA ${inv.tpa_name}`}</span> : null}</dd>
              <dt className="text-muted-foreground font-semibold">Total</dt>
              <dd className="text-right font-mono font-bold text-emerald-500" data-testid="pos-invoice-total">{formatCurrency(inv.total)}</dd>
              {result.change_given > 0 && (
                <>
                  <dt className="text-amber-500 font-semibold">Troco a devolver</dt>
                  <dd className="text-right font-mono font-bold text-amber-500" data-testid="pos-invoice-change">{formatCurrency(result.change_given)}</dd>
                </>
              )}
              {result.gift_card_balance !== null && result.gift_card_balance !== undefined && (
                <>
                  <dt className="text-muted-foreground">Saldo restante do cartão</dt>
                  <dd className="text-right font-mono">{formatCurrency(result.gift_card_balance)}</dd>
                </>
              )}
              {result.customer_balance !== undefined && (
                <>
                  <dt className="text-muted-foreground">Saldo do cliente</dt>
                  <dd className="text-right font-mono">{formatCurrency(result.customer_balance)}</dd>
                </>
              )}
            </dl>
            <POSEmailInvoice invoice={inv} />
            <DialogFooter className="grid grid-cols-3 gap-2 sm:space-x-0">
              <Button variant="outline" onClick={() => printInvoice(inv, settings || {}, "thermal80")} className="gap-1.5" data-testid="pos-print-thermal-btn">
                <Printer className="w-4 h-4" /> Talão
              </Button>
              <Button variant="outline" onClick={() => printInvoice(inv, settings || {}, "a4")} className="gap-1.5" data-testid="pos-print-a4-btn">
                <FileText className="w-4 h-4" /> A4
              </Button>
              <Button className="bg-emerald-600 hover:bg-emerald-500 text-white" onClick={onClose} data-testid="pos-invoice-close-btn">
                Nova Venda
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
